import script from "./approval-deploy-control.vue?vue&type=script&lang=ts&setup=true"
export * from "./approval-deploy-control.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__